import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { firstLetterCapitalize } from './helpers/keycloak'

Vue.use(Router)

let realmTenant = window.location.pathname
  .replace(/\/\//g, '/')
  .replace(/^\/([^\/]*).*$/, '$1')
realmTenant = realmTenant || 'Standard'

global.realm_tenant = firstLetterCapitalize(realmTenant)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL + realmTenant,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ]
})
